export default __webpack_public_path__ + "static/media/refundable.0e481ccf.svg";